import { COPYRIGHT_POLICY_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[COPYRIGHT_POLICY_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'Copyright Policy',
		bannerSubText: '',
	},
}
